import type { MutableRefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

const ANIMATION_DURATION = 2000;

export function useBubbleAnimation(
  enabled: boolean,
  skip: boolean,
  interval: number
) {
  const [animationActive, setAnimationActive] = useState(false);
  const animationIntervalRef: MutableRefObject<NodeJS.Timeout | null> =
    useRef(null);

  useEffect(() => {
    const clear = () => {
      if (animationIntervalRef.current) {
        clearInterval(animationIntervalRef.current);
      }
    };

    const start = () => {
      setAnimationActive(true);

      setTimeout(() => {
        setAnimationActive(false);
      }, ANIMATION_DURATION);
    };

    if (!enabled || skip) {
      setAnimationActive(false);
      clear();

      return;
    }

    if (enabled && !interval) {
      start();
    } else {
      animationIntervalRef.current = setInterval(
        () => {
          start();
        },
        interval * 1000 + ANIMATION_DURATION
      );
    }

    return () => {
      clear();
    };
  }, [skip, enabled, interval]);

  return animationActive;
}
